import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-main-gestao-bolseiros',
    imports: [
        RouterOutlet,
    ],
    templateUrl: './main-gestao-bolseiros.component.html',
    styleUrl: './main-gestao-bolseiros.component.scss',
    standalone: true
})
export class MainGestaoBolseirosComponent {

}
